import axios from "axios";
import { customStyles, HOST_URL } from "../../helpers/constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  LAUNCH_VIEWER,
  MODEL_FILTER_STATE,
  SELECTED_MODELS,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import {
  ARCHIVED_MARKUPS,
  CREATED_BY_LIST,
  CREATED_FOR_LIST,
  FILTERED_MARKUPS,
  MARKUPS_LOADING,
  PROJECT_MARKUP_DATA,
  updateMarkupState,
} from "../../helpers/reducers/MarkupReducer";
import { Form } from "react-bootstrap";

const LegacyModelSelector = ({ updateMarkupData }) => {
  const { selectedProject, allDocs, legacyModels } = useSelector(
    (state) => state.globalReducer,
  );
  const { selectedModels } = useSelector((state) => state.modelReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedProject) {
      fetchMarkups();
    }
  }, [selectedProject]);

  const modelSelected = (models) => {
    //loop over models and create an array of selected models to dispatch to the store
    let newSelectedModels = [];
    models.forEach((model) => {
      if (model.completeObj.visible) {
        newSelectedModels.push(model.completeObj);
      } else {
        const selectedModel = {
          id: model.completeObj.relationships.derivatives.data.id,
          documentName: model.completeObj.attributes.name,
          storageLocation:
            model.completeObj.relationships.storage.meta.link.href,
          task: null,
          status: null,
          sharedRevision: null,
          publishedRevision: null,
          projectAssetTaskId: null,
          selectedVersion: null,
          asset: null,
          versions: null,
          visible: true,
          discipline: null,
        };
        newSelectedModels.push(selectedModel);
      }
    });
    dispatch(
      updateModelState({
        value: false,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateModelState({
        value: newSelectedModels,
        stateName: SELECTED_MODELS,
      }),
    );
  };

  const sortArray = (arr, fieldToSort) => {
    let tempField = fieldToSort.toString();
    return arr.sort((a, b) => a[tempField] - b[tempField]);
  };

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };

  const fetchMarkups = (projectAsset) => {
    dispatch(
      updateMarkupState({
        value: true,
        stateName: MARKUPS_LOADING,
      }),
    );
    const projectId = selectedProject[0].id;
    // let formData = new URLSearchParams();
    // let formData = new FormData();

    // formData.append(
    //   "formData",
    //   JSON.stringify({
    //     projectId: projectId,
    //     projectAsset: projectAsset?.processArea,
    //   }),
    // );
    axios({
      method: "get",
      url: HOST_URL + "/markups/getMarkups",
      params: { projectId: projectId, projectAsset: projectAsset?.processArea },
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
      withCredentials: true,
    })
      .then((response) => {
        dispatch(
          updateMarkupState({
            value: response.data,
            stateName: PROJECT_MARKUP_DATA,
          }),
        );
        // updateMarkupData(response);
        let tempFilteredMarkups = { data: [] };
        let tempArchivedMarkups = { data: [] };
        response.data.forEach((markup) => {
          if (markup.archived) {
            tempArchivedMarkups.data.push(markup);
          } else {
            tempFilteredMarkups.data.push(markup);
          }
        });
        tempFilteredMarkups.data = sortArray(tempFilteredMarkups.data, "id");
        dispatch(
          updateMarkupState({
            value: tempFilteredMarkups,
            stateName: FILTERED_MARKUPS,
          }),
        );
        dispatch(
          updateMarkupState({
            value: tempArchivedMarkups,
            stateName: ARCHIVED_MARKUPS,
          }),
        );
        dispatch(
          updateMarkupState({
            value: false,
            stateName: MARKUPS_LOADING,
          }),
        );
        const tempCreatedBy = tempFilteredMarkups.data.map((markup) => {
          return markup.userName;
        });

        if (tempCreatedBy) {
          const uniqueCreatedBy = removeDuplicates(tempCreatedBy);
          dispatch(
            updateMarkupState({
              value: uniqueCreatedBy,
              stateName: CREATED_BY_LIST,
            }),
          );
        }

        const tempMarkups = tempFilteredMarkups.data.filter((markup) => {
          if (markup.createdFor) {
            return markup.createdFor;
          }
        });
        const tempCreatedFor = [];
        tempMarkups.forEach((markup) => {
          if (typeof markup.createdFor === "string") {
            tempCreatedFor.push(markup.createdFor);
          } else {
            tempCreatedFor.push(...markup.createdFor);
          }
        });
        if (tempCreatedFor) {
          const uniqueCreatedFor = removeDuplicates(tempCreatedFor);
          dispatch(
            updateMarkupState({
              value: uniqueCreatedFor,
              stateName: CREATED_FOR_LIST,
            }),
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const filterStyles = {
    ...customStyles,
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
      fontSize: "12px",
    }),
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      background:
        "linear-gradient(120deg, rgba(58,58,58,0.34) 0%, rgba(0,93,133,0.42) 100%)",
      borderColor: state.isFocused
        ? "rgba(147,213,0,0.72)"
        : "rgba(242,242,242,0.34)",
      minHeight: "34px",
      borderRadius: "14px",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(147,213,0,0.24), 0 8px 18px rgba(58,58,58,0.22)"
        : "0 8px 18px rgba(58,58,58,0.2)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.7)",
    }),
    input: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "rgba(242,242,242,0.95)",
      background: state.isSelected
        ? "linear-gradient(120deg, rgba(147,213,0,0.42), rgba(156,197,202,0.28))"
        : state.isFocused
          ? "linear-gradient(120deg, rgba(147,213,0,0.26), rgba(156,197,202,0.2))"
          : "rgba(0,0,0,0)",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      border: "1px solid rgba(242,242,242,0.24)",
      background:
        "linear-gradient(165deg, rgba(58,58,58,0.96) 0%, rgba(0,93,133,0.92) 100%)",
      boxShadow: "0 14px 28px rgba(58,58,58,0.28)",
      overflow: "hidden",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "rgba(156,197,202,0.95)",
    }),
    valueContainer: (provided) => ({
      ...provided,
      flexWrap: "wrap",
      height: "auto",
    }),
    multiValue: (provided) => ({
      ...provided,
      margin: "2px",
      background: "rgba(147,213,0,0.24)",
      border: "1px solid rgba(242,242,242,0.24)",
      borderRadius: "8px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.95)",
    }),
  };

  return (
    <>
      <div className="folderFiltersContainer">
        <h5>3D Model Selection</h5>
        {selectedProject && legacyModels.length > 0 && (
          <div className="bs-component" style={{ textAlign: "center" }}>
            <div className="row" style={{ paddingBottom: "10px" }}>
              {/* <div
                className="col-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "14px" }}>Asset</label>
              </div> */}
              <div className="col" style={{ paddingRight: "24px" }}>
                <Select
                  // className="basic-single"
                  className="mb-2"
                  // placeholder="Please select a model to view"
                  menuPortalTarget={document.body}
                  options={legacyModels?.map((model) => {
                    return {
                      value: model.attributes.displayName,
                      label: model.attributes.displayName,
                      completeObj: model,
                    };
                  })}
                  styles={filterStyles}
                  isSearchable={true}
                  onChange={(e) => {
                    modelSelected(e);
                  }}
                  value={selectedModels.map((model) => ({
                    value: model.documentName,
                    label: model.documentName,
                    completeObj: model,
                  }))}
                  isDisabled={!selectedProject}
                  isMulti
                  closeMenuOnSelect={false}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

//
export default React.memo(LegacyModelSelector);
